const API = process.env.REACT_APP_API_URL;

const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

// ================= ALL =================
export const getAllArticles = async (token) => {
  const res = await fetch(`${API}/memo/GetAllArticles`, {
    method: "GET",
    headers: headers(token),
  });

  if (!res.ok) throw new Error("Error ALL articles");
  return res.json();
};

// ================= Article by id =================
export const getArticleById = async (token, id) => {
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/Article/GetArticleById/${id}`,
    {
      method: "GET",
      headers: headers(token),
    },
  );

  if (!res.ok) throw new Error("Error ALL articles");
  return res.json();
};

// ================= DRAFT (EN ÉDITION) =================
export const getDraftArticles = async (token) => {
  const res = await fetch(`${API}/Article/GetArticlesInEdition`, {
    method: "GET",
    headers: headers(token),
  });

  if (!res.ok) throw new Error("Error DRAFT articles");
  return res.json();
};

// ================= PUBLISHED =================
export const getPublishedArticles = async (token) => {
  const res = await fetch(`${API}/Article/GetPublishedArticles`, {
    method: "GET",
    headers: headers(token),
  });

  if (!res.ok) throw new Error("Error PUBLISHED articles");
  return res.json();
};

// ================= ARCHIVED =================
export const getArchivedArticles = async (token) => {
  const res = await fetch(`${API}/Article/GetArticlesAlreadyPublished`, {
    method: "GET",
    headers: headers(token),
  });

  if (!res.ok) throw new Error("Error ARCHIVED articles");
  return res.json();
};

// ================= ARCHIVED BY YEAR =================
export const getArchivedArticlesByYear = async (token, year) => {
  const res = await fetch(
    `${API}/Article/GetArticlesAlreadyPublishedByYear/${year}`,
    {
      method: "GET",
      headers: headers(token),
    },
  );

  if (!res.ok) throw new Error("Error ARCHIVED articles by year");

  return res.json();
};

// ========================================
// LOCK ARTICLE
// ========================================

export const toggleArticleLock = async (token, id) => {
  const res = await fetch(`${API}/Article/ToggleReArticle/${id}`, {
    method: "POST",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.messageEn || "Error toggling article lock");
  }

  return data;
};

export const DeleteAttachment = async (token, id) => {
  const res = await fetch(`${API}/Article/ToggleReArticle/${id}`, {
    method: "POST",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.messageEn || "Error toggling article lock");
  }

  return data;
};

export async function DeleteFileAttachment(token, articleId, fileName) {
  const response = await fetch(
    `${API}/Article/DeleteFileAttachment/${articleId}?fileName=${encodeURIComponent(fileName)}`,
    {
      method: "DELETE",

      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Error deleting attachment.");
  }

  return data;
}
// ================= CREATE ARTICLE =================
export const createArticleold = async (token, payload) => {
  const res = await fetch(`${API}/Article/AddArticle`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.messageEn || "Error creating article");
  }

  return data;
};

// ================= CREATE ARTICLE =================

export const createArticle = async (token, payload) => {
  // ================= FORMDATA =================

  const formData = new FormData();

  formData.append("TitleFr", payload.titleFr);

  formData.append("TitleEn", payload.titleEn);

  formData.append("TextFr", payload.textFr);

  formData.append("TextEn", payload.textEn);

  // ================= FILES =================

  if (payload.files && payload.files.length > 0) {
    payload.files.forEach((item, index) => {
      formData.append(`Files[${index}].File`, item.file);

      formData.append(`Files[${index}].Language`, item.language);
    });
  }

  // ================= API =================

  const res = await fetch(`${API}/Article/AddArticle`, {
    method: "POST",

    headers: {
      Authorization: `Bearer ${token}`,
    },

    body: formData,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(
      data?.message || data?.messageEn || "Error creating article",
    );
  }

  return data;
};
// ================= update ARTICLE =================
export async function updateArticle(token, id, payload) {
  const formData = new FormData();

  formData.append("TitleFr", payload.titleFr);

  formData.append("TitleEn", payload.titleEn);

  formData.append("TextFr", payload.textFr);

  formData.append("TextEn", payload.textEn);

  if (payload.files && payload.files.length > 0) {
    payload.files.forEach((item, index) => {
      formData.append(`Files[${index}].File`, item.file);

      formData.append(`Files[${index}].Language`, item.language);
    });
  }

  const response = await fetch(`${API}/Article/UpdateArticle/${id}`, {
    method: "PUT",

    headers: {
      Authorization: `Bearer ${token}`,
    },

    body: formData,
  });

  if (!response.ok) {
    throw await response.json();
  }

  return await response.json();
}

//===============GetAttachments===================================
export const GetAttachments = async (token, id) => {
  const res = await fetch(`${API}/Article/GetAttachments/${id}`, {
    method: "Get",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.messageEn || "Error Getting attachements article");
  }

  return data;
};
//===============Download Attachment===================================
export const DownloadAttachment = async (token, fileName) => {
  const res = await fetch(`${API}/Article/DownloadAttachment/${fileName}`, {
    method: "GET",
    headers: headers(token),
  });

  if (!res.ok) {
    throw new Error("Error downloading attachment article");
  }

  // IMPORTANT
  const blob = await res.blob();

  return blob;
};

export const DownloadDetailsAttachment = async (token, id, fileName) => {
  const response = await fetch(`${API}/Article/download/${id}/${fileName}`, {
    method: "GET",
    headers: headers(token),
  });

  const blob = await response.blob();
  return blob;
};
//===============GetCategoryArticle===================================
export const GetCategoryArticle = async (token) => {
  const res = await fetch(`${API}/Article/GetCategoryArticle`, {
    method: "Get",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.messageEn || "Error Getting attachements article");
  }

  return data;
};

//===============GetCategoryArticle===================================
export const GetSignataire = async (token) => {
  const res = await fetch(`${API}/Employee/GetSignataire`, {
    method: "Get",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.messageEn || "Error Getting attachements article");
  }

  return data;
};

//===============Get External Department===================================
export const GetExternalDepartment = async (token) => {
  const res = await fetch(`${API}/Localization/GetExternalDepartment`, {
    method: "Get",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.messageEn || "Error Getting attachements article");
  }
  return data;
};

/*------------Get Province Tree----------------*/
export const GetProvinceRecipeTree = async (token) => {
  const res = await fetch(`${API}/Localization/GetProvinceTree`, {
    method: "Get",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.messageEn || "Error Getting attachements article");
  }
  return data;
};

/*------------------Save Article Properties-------------*/
export const SaveArticleProperties = async (token, payload) => {
  const res = await fetch(`${API}/Article/SaveArticleProperties`, {
    method: "PATCH",
    headers: headers(token),
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Error saving article properties");
  }

  return data;
};

/*------------------Get Article Details-------------*/
export const getArticleDetails = async (token, id) => {
  const res = await fetch(`${API}/Article/GetArticleDetails/${id}`, {
    method: "GET",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Error loading article");
  }

  return data;
};
/*------------------Delete Article-------------*/
export const DeleteArticle = async (token, id) => {
  const res = await fetch(`${API}/Article/DeleteArticle2/${id}`, {
    method: "DELETE",
    headers: headers(token),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Error deleting article");
  }

  return data;
};
